import React from 'react';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="retro-state-page error-boundary">
          <div className="retro-state-shell">
            <div className="retro-state-header retro-state-header--error">
              <h1>System Fault</h1>
              <span className="retro-state-code">500</span>
            </div>
            <div className="retro-state-body">
              <p className="retro-state-title">Something went wrong.</p>
              <p className="retro-state-detail">
                {this.state.error?.message || 'An unexpected runtime error occurred.'}
              </p>
              <div className="retro-state-actions">
                <button className="retro-state-btn" onClick={() => window.location.reload()}>
                  Reload Page
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
